/**
 * Deferred background will display the lowest resolution image first.
 * On page load the actual image will be downloaded (if needed)
 *
 * $breakpoint-small:                               580px !default;
 $breakpoint-medium:                              900px !default;
 //$breakpoint-medium:                              768px !default;
 $breakpoint-large:                               1160px !default;
 $breakpoint-xlarge:                              1220px !default;


 * */

(function($) {

    /**
     * start by getting the device width
     * */
    var deviceWidth = window.screen.width;

    var varDataAttr = '';

    if( deviceWidth >= 768 ){
        varDataAttr = 'data-src-medium';
    }
    if( deviceWidth >= 1068 ){
        varDataAttr = 'data-src-large';
    }

    /**
     * don't do anything unless you have a medium or larger image to work with
     * */
    if( varDataAttr != ""){

        $('.deferred-background').each( function(i){

            $obj = $(this);
            var $image_src = $(this).attr(varDataAttr);
            var $downloadingImage = $("<img>");
            $downloadingImage.attr("src", $image_src);
            $downloadingImage.load(function(){

                $obj.css({
                    'backgroundImage' : "url(" + $image_src  + ")"
                })


            });


        })

    }





})( jQuery );
